import React, {Component} from 'react'

import {
  Card,
  CardContent,
  IconButton,
  Typography,
} from 'material-ui'

import JobCardHeader from './JobCardHeader'
import SectionTitle from './SectionTitle'

// import Fade from 'material-ui/transitions/Fade'

import CloseIcon from 'material-ui-icons/Close'

import Logo from '../img/logo.png'

import {
  Primary,
  Title,
} from '../helper/consts'

const style = {
  closeIcon:{
    position: 'absolute',
    top: '0',
    right: '5px',
  },
  closedCard:{
    height:0,
    // width:0,
    opacity:0,
    margin:0,
  },
  aboutHeadline:{
    color:Primary,
  },
  aboutText:{
    marginBottom:'10px',
  }
}

export default class AboutCompany extends Component{
  constructor(props){
    super(props);

    this.state = {
      open:true,
    }
  }

  closeCard=()=>{
    this.setState({open:!this.state.open})
  }

  render(){
    const job = {
      logo:{
        downloadURLs:[Logo]
      },
      location:`${Title} is a new way to recruit. `,
      company: `About ${Title}`,
      companyURI:`https://${Title}.com/#/About`,
      title:''
    }
    return(
      <React.Fragment>
        {this.state.open && <SectionTitle title={`About ${Title}`} />}
        {this.state.open &&
          <Card className='card' >
            <JobCardHeader job={job} />
            <IconButton style={style.closeIcon} onClick={this.closeCard} color="primary" aria-label="Close About Card">
              <CloseIcon />
            </IconButton>
            <CardContent>
              <Typography style={style.aboutText} type="body1">
                {`Incredible employers are looking for talented people for exciting roles. If you're seeing this position, it means that someone thought you would be the perfect fit, or know someone who would be.`}
              </Typography>
              <Typography style={style.aboutHeadline} color='accent' type="body2">
                Ideal, 2 Connections Away
              </Typography>
              <Typography style={style.aboutText} type="body1">
                Research shows the ideal candidate is two connections away from your existing network; the best predictor of successful employment is team-fit and the most successful employees join through an internal referral.
              </Typography>
              <Typography style={style.aboutHeadline} color='accent' type="body2">
                Rewarding Referrals
              </Typography>
              <Typography style={style.aboutText} type="body1">
                {`If someone you refer, or someone they refer, joins the employer, you'll share in the internal company referral bonus that the company offers their employees.`}
              </Typography>
              <Typography style={style.aboutHeadline} color='accent' type="body2">
                Productivity Guaranteed
              </Typography>
              <Typography style={style.aboutText} type="body1">
                Referrals work. Satisfaction with the successful candidate is guaranteed.
              </Typography>
            </CardContent>
          </Card>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutCompany.js